import { render, staticRenderFns } from "./SidebarContainer.vue?vue&type=template&id=2d5ef845&scoped=true&"
import script from "./SidebarContainer.vue?vue&type=script&lang=js&"
export * from "./SidebarContainer.vue?vue&type=script&lang=js&"
import style0 from "./SidebarContainer.vue?vue&type=style&index=0&id=2d5ef845&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5ef845",
  null
  
)

export default component.exports